// src/services/bqlSystemManageApi.js
import axios from 'utils/axiosClient';

export async function getThongTinHanhSinhDirect() {
    return axios.get('/BQLSystemManage/hanhsinhs-active');
}
export async function getSwitchUser(maHs) {
    return axios.get(`/BQLSystemManage/switch-user/${maHs}`);
}
